export const useFieldManagement = () => {
    const disabled = inject(fieldsDisabledKey)

    return {
        fieldsDisabled: disabled
    }
}
